import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useLanguage } from '../../hooks/useLanguage';
import { Category } from '../../types/api';

interface CategoryBreadcrumbProps {
  category?: Category;
  parentCategory?: Category;
}

export function CategoryBreadcrumb({ category, parentCategory }: CategoryBreadcrumbProps) {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  return (
    <nav className="flex items-center gap-2 text-sm font-body mb-6" aria-label="Breadcrumb">
      <Link
        to="/catalog"
        className="text-neutral-medium hover:text-brand-accent transition-colors"
      >
        {t('catalog.breadcrumb.home')}
      </Link>
      
      <span className="text-neutral-medium">/</span>

      {parentCategory && (
        <>
          <Link
            to={`/catalog/category/${parentCategory._id}`}
            className="text-neutral-medium hover:text-brand-accent transition-colors"
          >
            {currentLanguage === 'ar' ? parentCategory.name : parentCategory.nameEn}
          </Link>
          <span className="text-neutral-medium">/</span>
        </>
      )}

      {category && (
        <span className="text-brand-accent font-semibold">
          {currentLanguage === 'ar' ? category.name : category.nameEn}
        </span>
      )}
    </nav>
  );
}

